import { useCallback, useState } from "react";
import { JSEditor } from "../core/ui/JSEditor";
import { Icon } from "../core/ui/icons";
import { CalculatedElement, EventContext, PresenterMessages, useContainer, usePresenter, usePresenterEvents } from "./types";
import { useData } from "../core/hooks/useData";
import { useDebounce } from "../core/hooks/useDebounce";

export function Calc(props: {
	def: CalculatedElement,
}) {

	const presenter = usePresenter();
	const container = useContainer();
	const data = useData();

	function recalc(msg: any) {
		if (!props.def.script) return;

		const eventContext: EventContext = {
			presenter,
			container,
			def: props.def,
			type: "change",

			debugContext: [
				"Calc",
				"recalc",
				props.def.id,
			]
		}

		const value = presenter.scriptEngine.run(
			props.def.script,
			eventContext,
			[
				{
					name: "data",
					obj: data,
				},
				{
					name: "msg",
					obj: msg,
				},
			]
		);

		// for calculated values just quitely set the value and don't trigger further change events
		const obj = data.value as any;
		obj[props.def.id] = value;
		//data.setValue(props.def.id, value);
	}

	// let hDebounceCalc: any;

	usePresenterEvents(presenter, useCallback((msg: any) => {
		// if (msg.type === "change") {
		// 	recalc();
		// } else 

		if (msg.type === PresenterMessages.RECALC) {
			if (msg.prop && msg.prop !== props.def.id) return;

			// // is a specific prop being requested?
			// if (msg.prop) {
			// 	if (props.def.id === msg.prop) {
			// 		if (hDebounceCalc) clearTimeout(hDebounceCalc);
			// 		hDebounceCalc = setTimeout(() => {
			// 			debugger;
			// 			recalc(msg);
			// 		}, 50);
			// 	}

			// } else {
			// 	// just a general request to recalc
				if (!props.def.calcOnSaveOnly) {
					recalc(msg);
				}	
			// }

		} else  if (msg.type === PresenterMessages.BEFORE_SAVE) {
			if (props.def.calcOnSaveOnly) {
				recalc(msg);
			}

		}

	}, []));

	if (presenter.designMode) {
		return (
			<div className="flex horiz gap-2 padding-left-5 bg-brand-primary text-inverse radius-small">
				<Icon type="calc" />
				<b>{props.def.id}</b>
				{props.def.calcOnSaveOnly && <div className="tag secondary">Save Only</div>}
				{props.def.defaultValue && <div className="tag primary">{props.def.defaultValue}</div>}
				{(props.def.script) && <JSEditor object={props.def} prop="script" />}
			</div>
		);
	} else {
		// not rendering anything in actual form instance, but need to run the calc
		return null;
		// return (
		// 	<div><b>{props.def.id}</b>: {JSON.stringify((data.value as any)[props.def.id])}</div>
		// )
	}

}